import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'

export class FinancesService extends BaseService {
  static get entity() {
    return 'finances'
  }

  static async getReport(params = {}) {
    try {
      const response = await this.request({ auth: true }).get(
        `${this.entity}/report?${this.querystring(params)}`
      )

      // Set initial state `hidden` for all datasets, but not `C+C`
      response.data.datasets.forEach((item) => {
        if (item.label === 'C+C') item.hidden = false
        else item.hidden = true
      })

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
}
